import { getConfig } from '@/utils/config/config';
import { COOKIES, getCookieValue, removeCookie } from '@/utils/cookies';
import { clearPromoProgressViewedSession } from '@/utils/rewards-hub/promo-progress-viewed-session';

export const removeSession = () => {
    console.log('[Session] Remove invalid session');
    const config = getConfig();

    /** Account UM: This was added to make sure no date is stored in localStorage from the previous session **/
    localStorage.removeItem('session-casino');
    localStorage.removeItem('session-sportsbook');
    localStorage.removeItem('session-poker');
    clearPromoProgressViewedSession();

    removeCookie(COOKIES.AUTH_TOKEN, '/', config.rootDomain);
    removeCookie(COOKIES.LOGIN_TOKEN, '/', config.rootDomain);
    removeCookie(COOKIES.USER_ID, '/', config.rootDomain);
    localStorage.removeItem(COOKIES.X_GEOCOMPLY_TOKEN);
};

/**
 * @deprecated
 * use getServerContext or useGlobalContext instead
 */
export const isLoggedIn = async () => {
    const loginToken = await getCookieValue(COOKIES.LOGIN_TOKEN);
    const authToken = await getCookieValue(COOKIES.AUTH_TOKEN);

    return Boolean(authToken && loginToken);
};
